import * as Common from "../../commons/common"

export class Sheet {
  grade: number = 0
  name: string = ""
  curriculum_id: number = 0
  subject_name: string = ""
  subject_code: string
  sheet_type: number
  exec_date: string
  api_type: number
  page_count: number
  course_id: string
  course_name: string
  course_work_id: string

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.sheet_type = sheet.sheet_type;
    this.exec_date = sheet.exec_date;
    this.api_type = sheet.api_type;
    this.page_count = sheet.page_count;
    this.course_id = sheet.course_id;
    this.course_name = sheet.course_name;
    this.course_work_id = sheet.course_work_id;
  }
}

export class Examinee {
  id: number
  sheet_id: number
  course_id: string
  course_name: string
  room_name: string
  student_no: number
  student_no_character: string
  student_name: string
  is_stop_publishing: boolean
  last_sent_at: string
  score: string
  api_student_id: string
  student_id: string
  email: string
  base64Images: string[] = []
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  returnCompleted: boolean = false
  run_at: string
  is_reservation_send_error: boolean

  constructor(examinee: any){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.course_id = examinee.course_id;
    this.course_name = examinee.course_name;
    this.room_name = examinee.room_name;
    this.student_no = examinee.student_no;
    this.student_no_character = examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.is_stop_publishing = examinee.is_stop_publishing;
    const last_sent_at = Common.formatDate(examinee.last_sent_at, 'yyyy年MM月DD日 HH:mm:ss');
    this.last_sent_at = last_sent_at ? last_sent_at : "-";
    this.score = `${examinee.score}点`;
    this.api_student_id = examinee.api_student_id;
    this.student_id = examinee.student_id;
    this.email = examinee.email;
    this.sheetActivities = examinee.sheet_activities;
    this.run_at = Common.formatDate(examinee.run_at, 'yyyy年MM月DD日 HH:mm:ss 返却予定');
    this.is_reservation_send_error = examinee.is_reservation_send_error;
  }
}

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export interface CourseWork {
  id: string
  title: string
  description: string
  creation_time: string
  update_time: string
  individual_students_options: IndividualStudentsOptions
  assignee_mode: string
}

/**
 * 個別生徒に課題が割り当てられている場合のオプション
 */
interface IndividualStudentsOptions {
  /**
   * 課題が割り当てられている生徒のIDのリスト。
   */
  student_ids: string[];
}

export class CourseWorkCondition {
  title: string = ""
  creation_time_from: string = ""
  creation_time_to: string = ""
  update_time_from: string = ""
  update_time_to: string = ""
}